export default "__VITE_ASSET__c952f5b4__"